import { render, staticRenderFns } from "./SearchArbitrage.vue?vue&type=template&id=4cc1f606&scoped=true"
import script from "./SearchArbitrage.vue?vue&type=script&lang=js"
export * from "./SearchArbitrage.vue?vue&type=script&lang=js"
import style0 from "./SearchArbitrage.vue?vue&type=style&index=0&id=4cc1f606&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cc1f606",
  null
  
)

export default component.exports